var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("D:/workspace/indivior-listmypractice-release/frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/views/components/header-bar.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<section class=\"header-bar hidden\">\r\n    <div class=\"container\">\r\n        <div class=\"row\">\r\n            <div class=\"six columns\">\r\n                <h2 class=\"treatment-provider hidden\">[Treatment Provider]</h2>\r\n                <p class=\"hcp-type hidden\">[HCP Type]</p>\r\n                <svg class=\"svg--icon-loading\" id=\"user-details-loading\">\r\n                  <use xlink:href=\"#icon-loading\"></use>\r\n                </svg>\r\n            </div>\r\n            <div class=\"four columns\">\r\n                <p class=\"npi-number hidden\"><strong>NPI</strong> <span>[NPI Number]</span></p>\r\n                <p class=\"dea-number hidden\"><strong>DEA</strong> <span>[List of DEA Numbers]</span></p>\r\n            </div>\r\n            <div class=\"two columns text-right\">\r\n                <a href=\"#\" class=\"logout\" aria-label=\"logout\">Logout</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/views/components/header-bar.njk"] , dependencies)